// global
export const INIT_APP = 'INIT_APP'
export const FINISH_ONBOARDING = 'FINISH_ONBOARDING'
export const RESET_ONBOARDING = 'RESET_ONBOARDING'
export const SET_PATIENT_GROUP = 'SET_PATIENT_GROUP'
export const TOGGLE_PATIENT_GROUP_MODAL = 'TOGGLE_PATIENT_GROUP_MODAL'
export const SET_RESOURCE = 'SET_RESOURCE'
export const SET_CURRENT_RESOURCE = 'SET_CURRENT_RESOURCE'
export const ERROR = 'ERROR'

// user
export const LOGIN_USER = 'LOGIN_USER'
export const CONTINUE_USER = 'CONTINUE_USER'
export const REFRESH_USER = 'REFRESH_USER'
export const REGISTER_USER = 'REGISTER_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const AUTH_LOAD_USER = 'AUTH_LOAD_USER'
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA'
export const AUTH_LOAD_ERROR = 'AUTH_LOAD_ERROR'
export const CHANGE_USER_EMAIL = 'CHANGE_USER_EMAIL'
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const VERIFY_EMAIL_ADDRESS = 'VERIFY_EMAIL_ADDRESS'
export const REQUEST_VERIFY_EMAIL_ADDRESS = 'REQUEST_VERIFY_EMAIL_ADDRESS'
export const SET_PRIVACY_SETTINGS = 'SET_PRIVACY_SETTINGS'

// news
export const GET_NEWS_LIST = 'GET_NEWS_LIST'
export const GET_NEWS_ARTICLE = 'GET_NEWS_ARTICLE'

// locations
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_DISTRICTS = 'SET_DISTRICTS'